import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { TeamDashboardPageComponent } from "./team-dashboard-page.component";

export const teamDashboardPageRoute = new OrganisationPageRouteBuilder<{ teamId: number }>()
    .usingNgComponent("adapt-team-dashboard-page", TeamDashboardPageComponent)
    .atOrganisationUrl("/team/:teamId/dashboard")
    .redirectToThisRouteFromOrganisationUrl("people/teams/:teamId/dashboard")
    .withTitle("Team Dashboard")
    .build();
